<template>
  <div class="p-5">
    <div class="container-fluid">
      <div class="row size-column">
        <div class="col-xxl-12 col-md-12 box-col-12 grid-ed-12">
          <div class="row">
            <div class="col-xxl-12 col-md-12 col-sm-12 box-col-12">
              <div class="card mb-5">
                <div class="card-body">
                  <h2 class="fw-bold">Support</h2>
                  <p>
                    You can see an overview of your ticket here. You also have
                    the ability to open up a new support rquest, whenever you
                    open up a new ticket, please make sure to describe as much
                    as possible.
                  </p>

                  <TableComponent
                    :columns="myTableColumns"
                    :tableData="tickets"
                    :rows="5"
                  >
                    <template #addButton>
                      <button
                        class="btn btn-block bg-mcd-primary"
                        @click="reset()"
                        data-bs-toggle="modal"
                        data-bs-target="#newTicketModal"
                      >
                        <span style="font-size: 0.8em"><b>OpenTicket</b></span>
                      </button>
                    </template>

                    <Column
                      headerStyle="color: white; background-color: black"
                      field="content"
                      header="Ticket Summary"
                    >
                      <template #body="slotProps">
                        <b>{{ slotProps.data.title }}</b>
                        <p class="mb-2">
                          {{ slotProps.data.description }}
                        </p>

                        <span
                          class="btn btn-block"
                          :style="{
                            'background-color': slotProps.data.status_color,
                            fontSize: '0.8em',
                            color: slotProps.data.font_color,
                          }"
                          @click="viewTicket(slotProps.data)"
                          data-bs-toggle="modal"
                          data-bs-target="#viewTicketModal"
                        >
                          <b>{{ slotProps.data.status_text }}</b>
                        </span>
                        <span class="ml-3" style="fontsize: 0.8em">
                          Created at {{ slotProps.data.created_at }}
                        </span>
                        <hr />
                      </template>
                    </Column>
                  </TableComponent>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div id="modals">
    <Modal
      :modalTitle="'Open Ticket'"
      :modalSize="'modal-lg'"
      :id="'newTicketModal'"
    >
      <div class="card text-dark">
        <div class="card-body">
          <div class="mb-3">
            <label for="title" class="form-label">Title</label>
            <input
              class="form-control"
              id="title"
              v-model="ticket.title"
              placeholder="Enter Title"
            />
          </div>

          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <textarea
              type="email"
              class="form-control"
              id="description"
              v-model="ticket.description"
              placeholder="Enter Description"
            ></textarea>
          </div>
        </div>

        <div class="card-footer">
          <button
            type="button"
            class="btn bg-light-dark text-dark mt-4 float-right mx-2"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>
          <button
            @click="store()"
            class="btn btn-warning text-dark mt-4 float-right"
            data-bs-dismiss="modal"
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>

    <Modal
      :modalTitle="'Submitted Ticket'"
      :modalSize="'modal-lg'"
      :id="'viewTicketModal'"
    >
      <div class="card text-dark">
        <div class="card-body">
          <input type="hidden" v-model="ticket.id" />
          <div class="mb-3">
            <label for="title" class="form-label">Title</label>
            <input
              class="form-control"
              id="title"
              v-model="ticket.title"
              placeholder="Enter Title"
              disabled
            />
          </div>

          <div class="mb-3">
            <label for="description" class="form-label">Description</label>
            <textarea
              class="form-control"
              id="description"
              v-model="ticket.description"
              placeholder="Enter Description"
              disabled
            ></textarea>
          </div>

          <br>

          <div v-if="user.email === 'admin@nextacloud.com' || ticket.status_text === 'Closed'">
            <hr />
            <h3>Nextacloud's Section</h3>
            <hr />

            <div class="mb-3">
              <label for="completed_name" class="form-label">Completed By</label>
              <input
                class="form-control"
                id="completed_name"
                v-model="ticket.completed_name"
                :disabled="ticket.status_text === 'Closed'"
              />
            </div>

            <div class="mb-3">
              <label for="title" class="form-label">Status</label>
              <select
                class="form-control"
                v-model="ticket.status"
                :disabled="(ticket.status_text === 'Closed')"
              >
                <option value="0">Open</option>
                <option value="1">In Progress</option>
                <option value="2">Closed</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="remarks" class="form-label">Remarks</label>
              <textarea
                class="form-control"
                id="remarks"
                v-model="ticket.remarks"
                placeholder="Enter remarks"
                :disabled="(ticket.status_text === 'Closed')"
              ></textarea>
            </div>
          </div>
        </div>

        <div class="card-footer">
          <button
            type="button"
            class="btn bg-light-dark text-dark mt-4 float-right mx-2"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>

          <button
            v-if="ticket.status !== 'Closed' && user.email === 'admin@nextacloud.com'"
            @click="update()"
            class="btn btn-warning text-dark mt-4 float-right"
            data-bs-dismiss="modal"
          >
            Submit
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>
    
<script>
import PrimaryButton from "@/components/PrimaryButton.vue";
import TableComponent from "@/components/TableComponent.vue";
import Modal from "@/components/ModalComponent.vue";

import {
  getRequest,
  patchRequest,
  postRequest,
} from "@/services/RequestService";

export default {
  components: {
    TableComponent,
    Modal,
    PrimaryButton,
  },

  data() {
    return {
      tickets: [],
      user: null,
      ticket: {
        id: null,
        title: null,
        description: null,
        remarks: null,
        status: 0,
        status_text: 'Open',
        completed_name: null,
      },
      myTableColumns: [{ field: "content" }],
      dataTableOptions: {
        paging: true, // Enable pagination
        searching: true, // Enable search functionality
        lengthChange: false,
        pagingType: "first_last_numbers",
      },
      table: null,
    };
  },
  methods: {
    async loadTickets(searchApi = null) {
      let api = searchApi;

      if (!searchApi) {
        api = "/tickets";
      }

      try {
        const authToken = localStorage.getItem("token");
        const user_details = JSON.parse(localStorage.getItem("user_details"));

        if (!authToken || !user_details) {
          throw new Error("Authentication information is missing.");
        }

        const response = await getRequest(api, {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        });

        if (response.data.success === false) {
          throw new Error("Error encountered. Please try again.");
        }

        this.tickets = response.data.data;
      } catch (error) {
        console.error("Error fetching API data:", error);
      }
    },

    async store() {
      let response = await postRequest(
        "/tickets",
        {
          title: this.ticket.title,
          description: this.ticket.description,
        },
        true
      );

      if (!response.data.success) {
        return this.$swal({
          icon: "error",
          text: response.data.message,
          confirmButtonText: "Close",
        });
      }

      return this.$swal({
        icon: "success",
        text: response.data.message,
      }).then(() => {
        window.location.reload();
      });
    },

    async update() {
      let response = await patchRequest(
        "/tickets/" + this.ticket.id + "/update",
        {
          title: this.ticket.title,
          description: this.ticket.description,
          completed_by: this.ticket.completed_name,
          remarks: this.ticket.remarks,
          status: this.ticket.status,
        }
      );

      if (!response.data.success) {
        return this.$swal({
          icon: "error",
          text: response.data.message,
          confirmButtonText: "Close",
        });
      }

      return this.$swal({
        icon: "success",
        text: response.data.message,
      }).then(() => {
        window.location.reload();
      });
    },

    viewTicket(ticket) {
      this.reset();

      this.ticket.id = ticket.id;
      this.ticket.title = ticket.title;
      this.ticket.description = ticket.description;
      this.ticket.remarks = ticket.remarks;
      this.ticket.status = ticket.status;
      this.ticket.status_text = ticket.status_text;
      this.ticket.completed_name = ticket.completed_name;
    },

    reset() {
      this.ticket.id = null;
      this.ticket.title = null;
      this.ticket.description = null;
      this.ticket.remarks = null;
      this.ticket.status = 0;
      this.ticket.status_text = 'Open';
    },
  },

  async created() {
    this.user = JSON.parse(localStorage.getItem("user_details"));
  },

  async mounted() {
    await this.loadTickets();
  },
};
</script>
    